/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

import { rhythm } from "../utils/typography"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "assets/profile-pic.jpg/" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  const { author, social } = data.site.siteMetadata
  return (
    <div
      style={{
        display: `flex`,
        flexDirection: `column`,
        marginBottom: rhythm(2.5),
      }}
    >
      <Image
        fluid={data.avatar.childImageSharp.fluid}
        alt={author.name}
        style={{
          marginTop: 10,
          marginRight: rhythm(1 / 2),
          marginBottom: 20,
          borderRadius: `1%`,
        }}
      />
      <p>
        I live in NYC and work at Dropbox. I recently graduated from Columbia, 
        where I studied physics and computer science. 
      </p>
      <p>
        I used to spend a lot of time 
        <a href={'https://www.youtube.com/watch?v=Y5m9URImdfA'} target="_blank" rel="noopener noreferrer"> playing piano</a> - 
        I was a lucky student of Martin Canin and Tatyana Dudochkin. I would love to talk about music with you.
      </p>
      <p>
        Say hi: <a href={'mailto:wuharvey@gmail.com'}>wuharvey@gmail.com</a>.
      </p>
    </div>
  )
}

export default Bio
